import BaseBankLogo, { BaseBankLogoProps, BankLogoConfig } from './BaseBankLogo';

type ChaseLogoProps = Omit<BaseBankLogoProps, 'config' | 'renderLogo'>;

const chaseConfig: BankLogoConfig = {
    colors: {
        background: '#2A5097',
        logo: 'white',
    },
    defaultAlt: 'Chase Bank Logo',
};

const renderChaseLogo = (colors: { background: string; border?: string; logo: string }, clipPathId: string) => (
    <>
        <g clipPath={`url(#${clipPathId})`}>
            <path
                d="M27.0444 14.8047C26.367 14.8047 25.8184 15.3534 25.8184 16.0299V24.6234H48.5181L38.1807 14.8055L27.0444 14.8047Z"
                fill={colors.logo}
            />
            <path
                d="M49.3483 27.2235C49.3483 26.5453 48.8036 25.999 48.1223 25.999H39.5312V48.6995L49.3444 38.3575L49.3483 27.2235Z"
                fill={colors.logo}
            />
            <path
                d="M36.9272 49.521C37.603 49.521 38.1517 48.9715 38.1517 48.2934V39.7031H15.4512L25.7901 49.5194L36.9272 49.521Z"
                fill={colors.logo}
            />
            <path
                d="M14.623 37.1037C14.623 37.7811 15.1717 38.333 15.8507 38.333H24.4401V15.6309L14.6246 25.9698L14.623 37.1037Z"
                fill={colors.logo}
            />
        </g>
        <defs>
            <clipPath id={clipPathId}>
                <rect width="36" height="36" fill="white" transform="translate(14 14)" />
            </clipPath>
        </defs>
    </>
);

/**
 * Chase Bank logo component with flexible sizing and color variants
 */
function ChaseLogo(props: ChaseLogoProps) {
    return <BaseBankLogo {...props} config={chaseConfig} renderLogo={renderChaseLogo} />;
}

export default ChaseLogo;
